import { FC, useState } from 'react';

import { LazyLoadImage } from '../lazy-load-image';
import styles from './roomstay-blog-customer-case-image-text.module.scss';

export interface CustomerCaseImageTextProps {
    image?: string;
    tag?: string;
    title?: string;
    description?: string;
    subDescription?: string;
}

const RoomStayBlogCustomerCaseImageText: FC<CustomerCaseImageTextProps> = (props) => {
    const { image, tag, title, description, subDescription } = props;

    return (
        <div className={styles.container}>
            <div className={styles.background}></div>
            <div className={styles.wrapperBox}>
                <div className={styles.boxLeft}>
                    {image && <LazyLoadImage imageUrl={image} alt="" objectFit="cover" />}
                </div>

                <div className={styles.boxRight}>
                    <div className={styles.tag} dangerouslySetInnerHTML={{ __html: tag || '' }}></div>
                    <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }}></h2>
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }}></div>
                    <div className={styles.subDescription} dangerouslySetInnerHTML={{ __html: subDescription || '' }}></div>
                </div>
            </div>
        </div>
    );
};

export default RoomStayBlogCustomerCaseImageText;
